exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1CaLC{display:block;line-height:1;position:fixed;min-height:393px;top:220px;right:-500px;padding:30px 20px 15px;width:500px;background:#f2f2f2;z-index:20;border:1px solid #e4e4e4;-webkit-transition:all .5s;-o-transition:all .5s;transition:all .5s}._1Wv-i{right:-3px}._2aAN6{right:-500px}._2BA46{background:url(" + require("./images/opinion.png") + ") no-repeat;width:45px;height:146px;display:block;text-indent:500px;outline:none;position:absolute;top:0;left:-45px;padding-top:10px}", ""]);

// exports
exports.locals = {
	"formulario_opinion": "_1CaLC",
	"show": "_1Wv-i",
	"hidden": "_2aAN6",
	"handle": "_2BA46"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/components/Contact/Contact.css
// module id = 1029
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13